/**
 * Country check - runs when user lands on the website.
 * Logs where the visitor is accessing from (IP-based geolocation), not the current market.
 * Uses Shopify Browsing Context API for detected country.
 */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var url = root.replace(/\/$/, '') + '/browsing_context_suggestions.json?country[enabled]=true';

  fetch(url)
    .then(function (res) {
      if (!res.ok) throw new Error('Browsing context request failed');
      return res.json();
    })
    .then(function (data) {
      var detected = data.detected_values && data.detected_values.country;
      if (detected && detected.handle) {
        console.log('Visitor accessing from:', detected.handle, detected.name ? '(' + detected.name + ')' : '');
      } else {
        console.log('Visitor country (geolocation) not available');
      }
    })
    .catch(function () {
      console.log('Visitor country (geolocation) not available');
    });
})();
